import { bigIntReplacer } from "@/utils/utils";
// 定义状态管理相关数据
const state = {
  walletAddress: '', // 连接钱包的地址
  connectWalletType: '', // 连接钱包的模式 1 clownWallet 2 okxWallet
  isConnectWallet: false, // 是否连接钱包
  currentNetworkID:7234,
  net: 0,
  gasPrice: 10000000000,
  slippage: 0.5,
  deadline: 20,
  multipath: false,
  transactions: {},
  block: 0,
  screenWidth: 1920,

}

// 修改状态管理值
const mutations = {
  SET_WALLETADDRESS(state, value) {
    state.walletAddress = value;
  },
  SET_CONNECTWALLETTYPE(state, value) {
    state.connectWalletType = value;
  },
  SET_CONNECTWALLET(state, value) {
    state.isConnectWallet = value;
  },
  SET_CURRENTNETWORKID(state, value) {
    state.currentNetworkID = value;
  },
  SETBLOCK: (state, block) => {
    state.block = block;
  },
  DELETETRANSACTIONS: state => {
    state.transactions = {};
  },
  SETTRANSACTIONS: (state, transactionsDetail) => {
    let tempObj = JSON.parse(JSON.stringify(state.transactions,bigIntReplacer));
    tempObj[transactionsDetail.hash] = transactionsDetail;
    state.transactions = tempObj;
  },
  SETTRANSACTIONSRECEIPT: (state, transactionsDetail) => {
    let tempObj = JSON.parse(JSON.stringify(state.transactions,bigIntReplacer));
    tempObj[transactionsDetail.hash].receipt = transactionsDetail.receipt;
    state.transactions = tempObj;
  },
  SETNET: (state, net) => {
    state.net = net;
  },
  SET_GASPRICE(state, gasPrice) {
    state.gasPrice = gasPrice;
  },
  SET_SLIPPAGE(state, slippage) {
    state.slippage = slippage;
  },
  SET_DEADLINE(state, deadline) {
    state.deadline = deadline;
  },
  SET_MULTIPATH(state, multipath) {
    state.multipath = multipath;
  },
  SET_SCREENWIDTH(state, screenWidth) {
    state.screenWidth = screenWidth;
  },
}

// 操作事件
const actions = {
  setWalletAddress({ commit }, value) {
    commit('SET_WALLETADDRESS', value);
  },
  setConnectWalletType({ commit }, value) {
    commit('SET_CONNECTWALLETTYPE', value);
  },
  setConnectWallet({ commit }, value) {
    commit('SET_CONNECTWALLET', value);
  },
  setCurrentNetworkID({ commit }, value) {
    commit('SET_CURRENTNETWORKID', value);
  },
  setBlock({ commit }, value) {
    commit('SETBLOCK', value);
  },
  deleteTransactions({ commit }, value) {
    commit('DELETETRANSACTIONS', value);
  },
  setTransactions({ commit }, value) {
    commit('SETTRANSACTIONS', value);
  },
  setTransactionsReceipt({ commit }, value) {
    commit('SETTRANSACTIONSRECEIPT', value);
  },
  setNet({ commit }, value) {
    commit('SETNET', value);
  },
  setGasPrice({ commit }, value) {
    commit('SET_GASPRICE', value);
  },
  setSlippage({ commit }, value) {
    commit('SET_SLIPPAGE', value);
  },
  setDeadline({ commit }, value) {
    commit('SET_DEADLINE', value);
  },
  setMultipath({ commit }, value) {
    commit('SET_MULTIPATH', value);
  },
  setScreenWidth({ commit }, value) {
    commit('SET_SCREENWIDTH', value);
  },
}

export default {
  namespaced: true, // 限定在当前模块的命名空间中
  state,
  mutations,
  actions
}